import { render, staticRenderFns } from "./THGUserFilters.vue?vue&type=template&id=4cccaf46&scoped=true"
import script from "./THGUserFilters.vue?vue&type=script&setup=true&lang=ts"
export * from "./THGUserFilters.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./THGUserFilters.vue?vue&type=style&index=0&id=4cccaf46&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cccaf46",
  null
  
)

export default component.exports